<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 选项卡 -->
    <div class="topClass">
      <div
        :class="topSelectActive == v.id ? 'selectActive' : 'select'"
        v-for="(v, i) in topSelectArr"
        :key="i"
        @click="changeSelect(v)"
      >
        {{ v.name }}
      </div>
    </div>

<div v-show="topSelectActive == 1">
  <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入用户电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            clearable
            v-model="form.state"
            filterable
            placeholder="全部"
          >
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="归属企业">
          <el-select
            clearable
            v-model="form.company"
            filterable
            placeholder="全部"
          >
            <el-option
              v-for="v in companyIdArr"
              :key="v.id"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="form.region"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getState();
            "
            >查询</el-button
          >
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
              getState();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <btns class="mgb-20" @exec="exec"></btns> -->
    <!-- 统计 -->
    <div class="flex aic mgt-15 mgb-15">
      <span class="mgr-50">申请总数：{{ stateForm.num }}</span>
      <span class="mgr-50">待审核：{{ stateForm.examineNum }}</span>
      <span class="mgr-50">已通过：{{ stateForm.agreeNum }}</span>
      <span class="mgr-50">已驳回：{{ stateForm.rejectNum }}</span>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="waterCard" label="水卡编号"> </el-table-column>
      <el-table-column prop="name" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" label="归属企业"> </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <!-- <el-table-column prop="address" label="是否绑定">
        <template slot-scope="scope">
          <span v-text="scope.row.userId ? '已绑定' : '未绑定'"></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="address" label="用户电话">
        <template slot-scope="scope">
          <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="初审状态">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.state == 1
                ? "待审核"
                : scope.row.state == 5
                ? "已驳回"
                : "已通过"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="复审状态">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.state == 5
                ? "- -"
                : scope.row.state == 3
                ? "已通过"
                : scope.row.state == 4
                ? "已通过"
                : scope.row.state == 7
                ? "已通过"
                : scope.row.state == 6
                ? "已驳回"
                : "待审核"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="终审状态">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.state == 5
                ? "- -"
                : scope.row.state == 6
                ? "- -"
                : scope.row.state == 7
                ? "已驳回"
                : scope.row.state == 4
                ? "已通过"
                : "待审核"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >

          <el-button 
  type="text" 
  size="small" 
  v-if="scope.row.state == 4 && scope.row.isRestore === false"
  @click="handleApply(scope.row)"
>数据恢复申请</el-button>
    <!-- 批量操作按钮 -->
    <!-- <el-button 
      v-if="multipleSelection.length > 0" 
      type="primary" 
      @click="handleApply()"
      class="mgt-10"
    >
      批量恢复申请
    </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
</div>

<div v-show="topSelectActive == 2">

  <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="huifuform" :model="huifuform" label-width="150px" :inline="true">
        <el-form-item label="水卡编号">
          <el-input
            v-model="huifuform.waterCard"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            v-model="huifuform.phone"
            placeholder="请输入用户电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
            <el-select clearable v-model="huifuform.state" filterable placeholder="全部">
              <el-option label="待审核" value="1"></el-option>
              <el-option label="已通过" value="2"></el-option>
              <el-option label="已驳回" value="3"></el-option>
              <!-- <el-option label="初审驳回" value="5"></el-option>
              <el-option label="复审驳回" value="6"></el-option>
              <el-option label="终审驳回" value="7"></el-option> -->
            </el-select>
          </el-form-item>
        <!-- <el-form-item label="归属企业">
          <el-select
            clearable
            v-model="huifuform.company"
            filterable
            placeholder="全部"
          >
            <el-option
              v-for="v in companyIdArr"
              :key="v.id"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="huifuform.region"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间">
          <el-date-picker
            v-model="huifuform.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="huifuform.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="gethuifuList();gethuifuStateForm();">查询</el-button>
          <el-button
            @click="
              huifuform = { startTime: '', endTime: '' };
              gethuifuList();
              gethuifuStateForm();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <btns class="mgb-20" @exec="exec"></btns> -->
    <!-- 统计 -->
    <div class="flex aic mgt-15 mgb-15">
      <span class="mgr-50">申请总数：{{ huiFuStateForm.num }}</span>
      <span class="mgr-50">待审核：{{ huiFuStateForm.examineNum }}</span>
      <span class="mgr-50">已通过：{{ huiFuStateForm.agreeNum }}</span>
      <span class="mgr-50">已驳回：{{ huiFuStateForm.rejectNum }}</span>
    </div>
    <!-- 表格 -->
    <el-table
      :data="huifutableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="waterCard" label="水卡编号"> </el-table-column>
      <el-table-column prop="name" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" label="归属企业"> </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <!-- <el-table-column prop="address" label="是否绑定">
        <template slot-scope="scope">
          <span v-text="scope.row.userId ? '已绑定' : '未绑定'"></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="address" label="用户电话">
        <template slot-scope="scope">
          <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
        </template>
      </el-table-column>
     <el-table-column prop="address" label="销售初审">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.state == 1
                    ? "待审核"
                    : scope.row.state == 5
                      ? "已驳回"
                      : "已通过"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="财务复审">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.state == 5
                    ? "- -"
                    : scope.row.state == 3
                      ? "已通过"
                      : scope.row.state == 4
                        ? "已通过"
                        : scope.row.state == 7
                          ? "已通过"
                          : scope.row.state == 6
                            ? "已驳回"
                            : "待审核"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="财务总监终审">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.state == 5
                    ? "- -"
                    : scope.row.state == 6
                      ? "- -"
                      : scope.row.state == 7
                        ? "已驳回"
                        : scope.row.state == 4
                          ? "已通过"
                          : "待审核"
                }}
              </span>
            </template>
          </el-table-column>
      <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
     <el-pagination
      class="mgt-20"
      background
      @size-change="handhuifuleSizeChange"
      @current-change="handhuifuleCurrentChange"
      :current-page="huifuPage"
      :page-sizes="[1]"
      :page-size="huifupageSize"
      layout=" prev, pager, next"
      :total="huifutotal"
    >
    </el-pagination>


</div>

    

    <el-dialog
      :title="'密码确认'"
      :visible.sync="pwdSureVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input
            show-password
            v-model="pwdForm.password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdSureVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 数据恢复弹框 -->
    <el-dialog
      title="数据恢复申请"
      :visible.sync="huiFuVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="40vh"
    >
      <el-form
        ref="huiFuFormRef"
        :rules="huiFuFormRules"
        :model="huiFuForm"
        label-width="80px"
      >
        <el-form-item label="申请备注" prop="applyMsg">
          <el-input
            maxlength="100"
            show-word-limit
            placeholder="请输入备注说明"
            type="textarea"
            v-model="huiFuForm.applyMsg"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请图片">
          <!-- 申请图片 -->
          <el-upload
            class="avatar-uploader"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="huiFuForm.applyImg"
            :http-request="uploadFile"
            :limit="3"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img width="100%" :src="imgs" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div style="color: red;">
        温馨提示：提交申请后需由相关工作人员审核，审核通过后将恢复数据。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="huiFuVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHuiFu">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      companyIdArr: [],
      zoneArr: [],
      tableData: [],
      multipleSelection: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      stateForm: {
        agreeNum: 0,
        examineNum: 0,
        num: 0,
        rejectNum: 0,
      },
      huiFuStateForm: {
        agreeNum: 0,
        examineNum: 0,
        num: 0,
        rejectNum: 0,
      },
      companyId: null,
      pwdForm: {
        password: "",
      },
      pwdSureVisible: false,
      huiFuVisible: false,
      huiFuForm: {
        applyMsg: '',
        applyImg: ''
      },
      huiFuFormRules: {
        applyMsg: [
          { required: true, message: '请输入备注说明', trigger: 'blur' }
        ]
      },
      currentRow: null,
      huifuid:'',
      imgsVisible: false,
      imgs: "",
      topSelectArr: [
        {
          id: 1,
          name: "水卡清零记录",
        },
        {
          id: 2,
          name: "水卡恢复记录",
        },
      ],
      topSelectActive: 1,
      huifuPage: 1, // 当前页，默认
      huifupageSize: 10, //每页显示多少条数据，默认
      huifuform: {},
      huifutableData: [],
      huifutotal: 0,
      huifumultipleSelection: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    if(this.$route.query.type==2){
      this.topSelectActive=2
    }
    // this.getcompanyId();
    this.getROLE();
    this.getZone();
    this.getList();
    this.getState();
    this.gethuifuList()
    this.gethuifuStateForm()
  },
  methods: {
    gethuifuList(){
      this.$api.waterCard
        .huifulist({
          pageNum: this.huifuPage,
          pageSize: this.huifupageSize,
          waterCard: this.huifuform.waterCard,
          phone: this.huifuform.phone,
          companyId: this.huifuform.company,
          regionId: this.huifuform.region,
          startTime: this.huifuform.startTime,
          endTime: this.huifuform.endTime,
          state: this.huifuform.state,
        })
        .then((res) => {
          if (res.code === 200) {
            this.huifutableData = res.data.rows;
            this.huifutotal = res.data.total;
          }
        });

    },
    gethuifuStateForm(){
      this.$api.waterCard
        .cardHuiFuListStat({
          pageNum: this.huifuPage,
          pageSize: this.huifupageSize,
          waterCard: this.huifuform.waterCard,
          phone: this.huifuform.phone,
          companyId: this.huifuform.company,
          regionId: this.huifuform.region,
          startTime: this.huifuform.startTime,
          endTime: this.huifuform.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.huiFuStateForm = res.data;
          }
        });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    handleDetail(row) {
       if(this.topSelectActive==1){
        this.$router.push({
          path: "/cardClearZero/detail",
          query: {
            id: row.id,
            type: 1,
            laiyuan:'applyForRecord'
          },
        });
      }else{
        this.$router.push({
          path: "/cardClearZero/huiFuDetail",
          query: {
            query: row,
            type: 0,
          },
        });
      }
    },
    getState() {
      this.$api.waterCard
        .cardClearZeroStat({
          type: 0,
          waterCard: this.form.waterCard,
          phone: this.form.phone,
          companyId: this.companyId,
          regionId: this.form.region,
          beginTime: this.form.startTime,
          endTime: this.form.endTime,
          state: this.form.state,
        })
        .then((res) => {
          if (res.code == 200) {
            this.stateForm = res.data;
          }
        });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .cardClearZeroCheckList({
          type: 0,
          pageNum: this.page,
          pageSize: this.pageSize,
          waterCard: this.form.waterCard,
          phone: this.form.phone,
          companyId: this.companyId,
          regionId: this.form.region,
          beginTime: this.form.startTime,
          endTime: this.form.endTime,
          state: this.form.state,
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    // getcompanyId() {
    //   this.$api.enterprise.enterpriseListPullNew().then((res) => {
    //     if (res.code === 200) {
    //       this.companyIdArr = res.data;
    //     }
    //   });
    // },

    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    handhuifuleSizeChange(val) {
      this.huifupageSize = val;
      this.gethuifuList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handhuifuleCurrentChange(val) {
      this.huifuPage = val;
      this.gethuifuList(this.page);
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    handleApply(row){
      console.log('恢复数据的id',row)
      this.huifuid = row.id
      this.currentRow = row || null;
      this.pwdForm = { password: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
      this.pwdSureVisible = true;
    },
    pwdSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误，请重新输入", "error");
                this.pwdForm = {};
              } else {
                this.pwdSureVisible = false;
                // 重置恢复表单
                this.huiFuForm = {
                  applyMsg: '',
                  applyImg: []
                };
                // 显示恢复弹窗
                this.huiFuVisible = true;
              }
            });
        } else {
          return false;
        }
      });
    },
    // 提交恢复申请
    submitHuiFu() {
      // 获取选中的ID列表
      let ids = [];
      if (this.currentRow) {
        // 单个选择
        ids.push(this.currentRow.id);
      } else if (this.multipleSelection.length > 0) {
        // 多个选择
        ids = this.multipleSelection.map(item => item.id);
      }
      
      if (ids.length === 0) {
        handleAlert("请选择要恢复的记录", "warning");
        return;
      }
      
      // 发送请求
      this.$api.waterCard
        .cardHuiFu({
          id: this.huifuid,
          applyMsg: this.huiFuForm.applyMsg,
          applyImg: String(this.huiFuForm.applyImg)
        })
        .then((res) => {
          if (res.code === 200) {
            handleAlert("恢复申请提交成功", "success");
            this.huiFuVisible = false;
            this.getList();
          } else {
            handleAlert(res.msg || "提交失败", "error");
          }
        });
    },
    // 处理图片上传
    handleRemove(file, fileList) {
      // 更新图片链接
      this.huiFuForm.applyImg = fileList
    },
    handlePictureCardPreview(file) {
      this.imgs = file.url;
      this.imgsVisible = true;
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          console.log(res.data, "res.data");

          // this.stageTreeForm.equipmentPhoto = URL.createObjectURL(params.file);
          // this.changeHeadImgform.headUrl = res.data[0];
          this.imgs = res.data[0];
          this.huiFuForm.applyImg.push({
            url: res.data[0],
          });
          // this.imgList.forEach((v) => {
          //   console.log(v, "哦哦哦");
          //   this.imgListUpload.push(v.url);
          // });
          // this.imgListUpload = this.imgListUpload.filter(
          //   (item, index, array) => {
          //     return array.indexOf(item) === index;
          //   }
          // );
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    changeSelect(item) {
      this.topSelectActive = item.id;
      this.huifuform = {};
      this.form={}
      if(this.topSelectActive == 1){
        this.getList()
      }else{
        this.gethuifuList()
      }
      // this.getFiles();
    },
  },
};
</script>

<style lang="scss" scoped>
.topClass {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 20px;
  .select {
    width: 350px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // border: 1px solid var(--input-border);
    background: var(--card-bg);
    font-size: 25px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .selectActive {
    width: 350px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // border: 1px solid var(--input-border);
    background: var(--accent);
    font-size: 25px;
    color: #fff;
    box-sizing: border-box;
    cursor: pointer;
  }
}
</style>
